module.exports = __webpack_public_path__ + "img/catering_menu_2.aa986818.jpg";